import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import installElementPlus from './plugins/element'
import './assets/font/font.css'
import 'default-passive-events'
const app = createApp(App)
installElementPlus(app)

app
    .use(router)
    .mount('#app')

app.config.globalProperties.$routes = 'home'


